import type { Locale } from 'date-fns';
import enUsLocale from 'date-fns/locale/en-US';

import { formatLong } from './formatLong';
import { localize } from './localize';

/**
 * @type {Locale}
 * @category Locales
 * @summary Cape Verdean Creole locale.
 * @language Cape Verdean Creole
 */
export const keaLocale: Locale = {
  code: 'kea',
  formatDistance: enUsLocale.formatDistance,
  formatLong,
  formatRelative: enUsLocale.formatRelative,
  localize,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
};
